import React from 'react';
export function HeroSection() {
  return <section className="min-h-screen bg-brand-black flex flex-col justify-end px-5 md:px-12 lg:px-24 relative pt-20 pb-24 md:pb-28 overflow-hidden" data-id="element-28">
      {/* Background video */}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-29">
        <source src="https://cdn.magicpatterns.com/uploads/xxP3isjsVDmZkAJwV9GJco/animate.MP4" type="video/mp4" data-id="element-30" />
      </video>

      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-brand-black/50 z-[1]" data-id="element-31" />

      {/* Bottom gradient for extra contrast near text */}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-brand-black/80 to-transparent z-[1]" data-id="element-32" />

      {/* Content */}
      <div className="max-w-7xl w-full mx-auto relative z-10" data-id="element-33">
        <div className="mb-6 md:mb-12" data-id="element-34">
          <div className="w-12 md:w-16 border-t border-brand-gold" data-id="element-35" />
        </div>

        <h1 className="font-display font-black uppercase text-[2.25rem] md:text-7xl lg:text-8xl leading-[0.9] tracking-tight" data-id="element-36">
          <span className="block text-brand-white mb-1 md:mb-2" data-id="element-37">
            AN EXCEPTIONAL OPPORTUNITY.
          </span>
          <span className="block text-brand-gold" data-id="element-38">CREMORNE, MELBOURNE.</span>
        </h1>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center z-10 animate-pulse" data-id="element-39">
        <div className="w-[1px] h-12 md:h-16 bg-brand-gold/70 mb-2" data-id="element-40" />
        <div className="w-2 h-2 border-b border-r border-brand-gold/70 transform rotate-45" data-id="element-41" />
      </div>
    </section>;
}